module.exports = __webpack_public_path__ + "img/social.a42090bd.jpg";